module.exports = __webpack_public_path__ + "9fae727304fa2e4df9ae894e93e1cfcb.gif";


//////////////////
// WEBPACK FOOTER
// ./assets/images/location-pin-current-transparent.gif
// module id = 1436
// module chunks = 249